// extracted by mini-css-extract-plugin
export default {"mCard":"mC-z","image":"nC-z","imageNoBackground":"oC-z","fullWidth":"pC-z"};